let googleMapsScriptPromise = null;

export function loadGoogleMapsScript(apiKey) {
  if (window.google && window.google.maps) {
    return Promise.resolve();
  }

  if (!googleMapsScriptPromise) {
    googleMapsScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        // console.log("Google Maps API loaded.");
        resolve();
      };

      script.onerror = () => {
        reject("Google Maps failed to load.");
      };

      document.head.appendChild(script);
    });
  }

  return googleMapsScriptPromise;
}
